import React, { useEffect, useState } from "react";
import { HttpService } from "../../services/httpService";
import { Order } from "../../interfaces/order";
import { GetAllClientResponses } from "../../services/orderService";

export interface ClientResponseFile {
  name: string;
}

interface DownloadClientResponseProps {
  order: Order;
  onClose: (message?: string) => void;
}

const DownloadClientResponse: React.FC<DownloadClientResponseProps> = ({
  order,
  onClose,
}) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [files, setFiles] = useState<ClientResponseFile[]>([]);
  const [selectedFile, setSelectedFile] = useState<string | null>(null);

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        setLoadingSpinner(true);
        const data: ClientResponseFile[] = await GetAllClientResponses(
          order.orderID,
        );
        if (!data) {
          throw new Error("No response from server");
        }
        if (data.length === 0) {
          setFiles([]);
          setSelectedFile(null);
          return;
        }
        setFiles(data);
        setSelectedFile(data[0].name);
      } catch (error) {
        console.error("Error fetching client response files:", error);
        setErrorMessage("Unable to fetch available documents.");
      } finally {
        setLoadingSpinner(false);
      }
    };

    fetchFiles();
  }, [order]);

  const handleDownload = async () => {
    if (!selectedFile) return;
    try {
      setLoadingSpinner(true);
      const blobUrl = await HttpService.getFileAdmin(
        "transfer-release-responses",
        order.orderID.toString(),
        selectedFile,
      );

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = selectedFile;
      link.click();
      URL.revokeObjectURL(blobUrl); // cleanup
    } catch (error) {
      console.error("Error downloading file:", error);
      setErrorMessage("Failed to download file.");
    } finally {
      setLoadingSpinner(false);
    }
  };

  return (
    <>
      <div className="background-mask" onClick={() => onClose()}></div>
      <div className="filter-popup">
        <div className="close-button-container">
          <button className="close-button" onClick={() => onClose()}>
            <i className="bi bi-x-circle"></i>
          </button>
        </div>
        <div className="filter-header">
          <h2>Download Client Response</h2>
          <div>Please select a document to download.</div>
        </div>
        <br></br>
        <div className="dialog-container">
          <div className="form-group">
            <select
              className="form-control"
              size={5}
              value={selectedFile || ""}
              onChange={(e) => setSelectedFile(e.target.value)}
            >
              {files.map((file) => (
                <option key={file.name} value={file.name}>
                  {file.name}
                </option>
              ))}
            </select>
          </div>
          <div className="action-buttons">
            <button
              className="smbtn btn-grey"
              onClick={handleDownload}
              disabled={!selectedFile}
            >
              Download Selected Document
            </button>
          </div>
          {errorMessage && <div className="error-message">{errorMessage}</div>}
        </div>
      </div>
      {loadingSpinner && (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      )}
    </>
  );
};

export default DownloadClientResponse;
